// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Volume } from './Volume';
import { VolumePrism } from './VolumePrism';
import { PrismRange } from './PrismRange';
import { Coordinate } from './Coordinate';
import { Airspace } from './Airspace';

export class Polygon2D implements IPolygon2D {
    exterior!: Coordinate[];
    interior!: Coordinate[][];

    constructor(data?: IPolygon2D) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exterior"])) {
                this.exterior = [] as any;
                for (let item of _data["exterior"])
                    this.exterior!.push(Coordinate.fromJS(item));
            }
            if (Array.isArray(_data["interior"])) {
                this.interior = [] as any;
                for (let item of _data["interior"])
                    this.interior!.push(item);
            }
        }
    }

    static fromJS(data: any): Polygon2D {
        data = typeof data === 'object' ? data : {};
        let result = new Polygon2D();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exterior)) {
            data["exterior"] = [];
            for (let item of this.exterior)
                data["exterior"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.interior)) {
            data["interior"] = [];
            for (let item of this.interior)
                data["interior"].push(item);
        }
        return data;
    }
}

export interface IPolygon2D {
    exterior: Coordinate[];
    interior: Coordinate[][];
}